<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>

    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>會員</p>
      </div>

      <el-form>
        <el-form-item label="會員賬號 ：">
          <input
            maxlength="100"
            disabled
            class="el-input__inner"
            type="text"
            v-model="userInfo.memberAccount"
          />
        </el-form-item>

        <el-form-item label="真實姓名 ：">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.realName"
          />
        </el-form-item>

        <el-form-item label="手機號碼 ：">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.phoneNumber"
          />
        </el-form-item>

        <el-form-item label="禁用功能 ：">
          <el-checkbox-group
            v-model="checkBlackList"
            @change="handleCheckedTypeChange"
          >
            <el-checkbox :label="1">登錄</el-checkbox>
            <el-checkbox :label="2">評論</el-checkbox>
            <el-checkbox :label="5">活动报名</el-checkbox>
            <el-checkbox :label="7">粉絲發信</el-checkbox>
            
            <!--<el-checkbox :label="3" >發帖</el-checkbox>-->
            <!--<el-checkbox :label="4" >社區評論</el-checkbox>-->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="禁用至 ：">
          <el-date-picker
            :picker-options="forbiddenOptions"
            v-model="downTime"
            type="datetime"
            placeholder="選擇時間"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="原因">
          <el-input
            type="textarea"
            autosize
            placeholder="請輸入原因"
            v-model="blackReason"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div class="bottomBtn">
        <!-- <div v-show="userInfo.authorizationCode=='1'" class="btn borderBtn" @click="delAuthInfo()">刪除實名認證</div> -->

        <div class="btn" @click="submitModify()">確認</div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "會員  /  黑名單  ",
      navtitle: "黑名單詳情",
      id: this.$route.query.id,
      authCode: "",
      userInfo: {
        memberAccount: "",
        realName: "",
        phoneNumber: ""
      },
      downTime: "",
      blackReason: "", // 原因
      blackType: 1,
      checkBlackList: [],
      forbiddenOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 限制只可以选择今天及今天之前的日期
        }
      },
      dialogVisible: false
    };
  },
  created() {
    let _this = this;
    _this.getUserDetails();
    _this.blackReason =
      localStorage.getItem("blackReason") == "null"
        ? ""
        : localStorage.getItem("blackReason");
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户信息详情
    getUserDetails() {
      let _this = this;
      _this
        .$get(
          `/request/blackMember/getBlackDetail/${_this.id}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.userInfo = {
              memberAccount: res.data.email,
              realName: res.data.realName,
              phoneNumber: res.data.iphone
            };
            _this.downTime = _this.$getTime(res.data.downTime);
            _this.checkBlackList = res.data.blackType.split(",").map(i => {
              return parseInt(i);
            });
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 修改提交
    submitModify() {
      let _this = this;

      if (_this.$getCaption(_this.blackReason)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "加入黑名單原因不能包含非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );
        return false;
      }

      if (_this.downTime === "" || _this.downTime === null) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇禁用到期時間", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }

      _this
        .$confirm("確定修改此黑名單詳情?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          console.log("1111");

          let param = {
            userId: _this.id,
            // blackList: _this.blackType,
            blackList:
              _this.checkBlackList.length === 1
                ? _this.checkBlackList[0]
                : _this.checkBlackList.join(","),
            blackListContent: _this.blackReason,
            downTime:
              typeof _this.downTime === "string"
                ? _this.downTime
                : _this.$formatDate(_this.downTime)
          };
          if (_this.checkBlackList.length == 0) {
            param.blackList = "6";
          }
          _this
            .$put(
              `request/blackMember/saveBlackList`,
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("黑名單詳情修改成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/blackList");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    handleCheckedTypeChange(value) {
      console.log(value);
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.contentDetails {
  .detailsContent {
    .is-disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
      padding-left: 16px;
    }
    input:disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
    }

    input.newsType {
      background: none;
      line-height: 40px;
      height: 40px;
      color: #606266;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/blackListDetails.vue